var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"font-weight-bold text-dark"},[_vm._v(_vm._s(_vm.mainCategory)+_vm._s(_vm.secondaryCategories?.length ? ';' : '.'))]),_vm._v(" "),(_vm.secondaryCategories?.length)?_c('span',[_vm._v(_vm._s(_vm.secondaryCategories.join('; '))+".")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }